module.exports = __webpack_public_path__ + "img/umi.9ed8aa2b.png";